import { Form, Select } from "antd";

import { FilterOption } from "@core/interfaces";

interface Props {
  data: FilterOption[];
  name: string;
  type: string;
  className?: string;
  placeholder?: string;
  onFinish: (values: any, type: string) => void;
}

const Selector = ({ data, name, type, className, placeholder, onFinish }: Props) => {
  return (
    <Form.Item name={name} className={className}>
      <Select
        onChange={(e) => onFinish(e, type)}
        placeholder={placeholder}
      >
        {data?.map((item: FilterOption) => (
          <Select.Option key={item.value} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default Selector;
